import { uploadFile as apiUploadFile } from './api';

/**
 * Upload a file to CommHub storage
 * @param file - The file to upload
 * @param _category - Category for organization (default: 'uploads') - unused in current implementation
 * @returns The URL of the uploaded file
 */
export async function uploadFile(file: File, _category: string = 'uploads'): Promise<string> {
  const result = await apiUploadFile(file);
  return result.url || result.file_url || '';
}

/**
 * Upload multiple files in parallel
 * @param files - Files to upload
 * @param category - Category for organization
 * @returns Array of uploaded file URLs
 */
export async function uploadMultipleFiles(files: FileList | File[], category: string = 'uploads'): Promise<string[]> {
  const urls = await Promise.all(
    Array.from(files).map(file => uploadFile(file, category))
  );
  return urls;
}

/**
 * Upload an image file specifically
 * @param file - Image file to upload
 * @returns The URL of the uploaded image
 */
export async function uploadImage(file: File): Promise<string> {
  return uploadFile(file, 'images');
}
